import "../css/BlogDetail.css"
import { useParams, NavLink,useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper'
import {logEvent } from "firebase/analytics";
import { analytics } from "../firebase";

interface post {
  title: string;
  date: string;
  text: string;
  image: string[];
}
export const BlogDetail = () => {
  logEvent(analytics, 'tap_BlogDetail', { custom_param: 'tap call triggered' });
    const history = useHistory();
  
  const openDetailClick = (index: number) => {
    history.push(`/BlogDetail/${index}`);
  };
  const isMobile = window.innerWidth <= 799;
  const { id } = useParams<{ id: string }>();  // URLパラメータから投稿IDを取得
  // console.log(id);
  const [post, setPost] = useState<post>();
  const [posts, setPosts] = useState<post[]>([]);
  useEffect(() => {
    // JSONファイルを読み込む
    fetch("../../static-data/blog_data.json")
      .then((response) => response.json())
      .then((data) => {
        setPosts(data); // 取得したデータをstateに保存
        setPost(data[parseInt(id)]); // 取得したデータをstateに保存
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [id]); // コンポーネントがマウントされたときに実行
  // ダミーデータ（実際はAPIなどでデータを取得することが一般的）
  const newObj = Object.fromEntries(
    Object.entries(posts).filter(([key]) => key !== id));

    const firstThreePosts = Object.entries(newObj)
    .slice(0, 3)
    .map(([key, value]) => ({ ...value, originalIndex: key }));

  const defaultImage = '../../static-data/default-image.webp'; // デフォルト画像のパス
  return (
    <div className='blog-detail-backgroud'>
      <h1>{post?.title}</h1>
      <div className='blog-detail-container'>
        <div className='blog-detail-img'>
          <Swiper
            spaceBetween={0} // スライド間のスペース
            slidesPerView={1} // 1度に表示するスライド数
            pagination={{ clickable: true }} // ページネーションを有効にする
            modules={[Navigation, Pagination]}
          >
            {post?.image.length === 0 ?
              <img src={defaultImage} alt={post?.title ? `${post.title} - デフォルト画像` : "デフォルト画像"} />
              : post?.image.map((image, ind) => (
                <SwiperSlide key={ind}>
                  <img
                    src={image}
                    alt={post?.title ? `${post.title} - 釣果${ind + 1}` : `釣果${ind + 1}`}
                  />
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
        <div className="blog-detail-text">
          
            {post?.text?.split("\n").map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
        </div>
      </div>
      <div style={{ "marginTop": "30px", "borderBottom": "black solid 0.1px" }}></div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
        <p style={{ fontSize: "20px" }}>最新記事</p>
        <p style={{ textAlign: "right" }}>
          <NavLink
            style={{
              fontSize: "20px",
              textDecoration: "underline",
              color: "black"
            }}
            activeClassName="active"
            exact
            to="/BlogList"
          >
            すべて表示
          </NavLink>
        </p>
      </div>
      <Swiper
        className="new-post-container-mobile"
        style={{ "marginTop": "30px" }}
        spaceBetween={20} // スライド間のスペース
        slidesPerView={1.4} // 1度に表示するスライド数
        pagination={{ clickable: true }} // ページネーションを有効にする
        modules={[Navigation, Pagination]}
        centeredSlides={true} // スライドを中央に配置
        loop={true}
        initialSlide={3}
        loopAdditionalSlides={2}
      >
        {Object.values(firstThreePosts).map((post, index) => (
          <SwiperSlide key={index}
          onClick={() => openDetailClick(Number(post.originalIndex))}>
            <div >
              <img
                src={post.image.length > 0 ? post.image[0] : defaultImage}
                alt={`First of ${post.title}`}
                className="image"
              />
              <span className="overlay-text">{post.title}</span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      {!isMobile && (
          <div className="image-container">
          {Object.values(firstThreePosts).map((post, index) => (
            <div key={index}
            onClick={() => openDetailClick(Number(post.originalIndex))}>
              <div 
              >
                <img
                  src={post.image.length > 0 ? post.image[0] : defaultImage}
                  alt={`First of ${post.title}`}
                  className="image"
                  
                />
                <span className="overlay-text">{post.title}</span>
              </div>

            </div>
          ))}
        </div>

      )}
    </div>
  );
};

